import Component from '@glimmer/component';

export default class DeluxePlayerMiniPlayerArtworkComponent extends Component {}
